var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1585 1199.41",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.43 -17.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1547.13 495a34.42 34.42 0 1 0 -34.42 34.43 34.42 34.42 0 0 0 34.42-34.43zm-34.42-75.73a75.74 75.74 0 1 1 -75.71 75.73 75.73 75.73 0 0 1 75.71-75.76z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1511.24 515.31a20.63 20.63 0 1 1 20.62-20.63 20.63 20.63 0 0 1 -20.62 20.63z",
    fill: "#5e72e4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.78 1196.64a20.62 20.62 0 0 1 20.62-20.64h123.73a20.63 20.63 0 1 1 0 41.25h-123.73a20.62 20.62 0 0 1 -20.62-20.61z",
    fill: "#ffc735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.51 1108.24a20.62 20.62 0 0 0 20.63 20.62h64a75.44 75.44 0 0 0 55-23.72 75.4 75.4 0 0 0 55 23.72h63.26a75.64 75.64 0 0 0 75.6-75.63 20.63 20.63 0 0 0 -41.26 0 34.39 34.39 0 0 1 -34.38 34.38h-63.25a34.39 34.39 0 0 1 -34.39-34.38v-138.9a74.27 74.27 0 0 0 -74.26-74.27v41.26a33 33 0 0 1 33 33v138.9a34.39 34.39 0 0 1 -34.38 34.38h-63.94a20.62 20.62 0 0 0 -20.63 20.64z",
    fill: "#2dce89",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.31 942a34.43 34.43 0 1 0 -34.42-34.42 20.65 20.65 0 1 1 -41.3 0 75.72 75.72 0 1 1 75.72 75.74 20.66 20.66 0 0 1 0-41.32z",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m633.78 130.64a34.38 34.38 0 1 0 -48.68 0 20.62 20.62 0 0 1 -29.2 29.13 75.63 75.63 0 1 1 107.08 0 20.62 20.62 0 0 1 -29.2-29.13z",
    fill: "#f5365c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m556.85 131.17a20.63 20.63 0 1 1 0 29.18 20.64 20.64 0 0 1 0-29.18z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.53 881.32a20.63 20.63 0 1 1 20.63-20.63 20.63 20.63 0 0 1 -20.63 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.56 947.63a34.42 34.42 0 1 0 -34.42 34.42 34.42 34.42 0 0 0 34.42-34.42zm-34.42-75.74a75.74 75.74 0 1 1 -75.71 75.74 75.73 75.73 0 0 1 75.71-75.74z",
    fill: "#ffc735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.48 770a42.6 42.6 0 0 0 -42.48 42.65v79.85a20.58 20.58 0 1 1 -41.15 0v-79.85a83.83 83.83 0 0 1 83.67-84z",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.44 913.15a20.63 20.63 0 1 1 20.62-20.63 20.63 20.63 0 0 1 -20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.85 968a20.63 20.63 0 1 1 20.62-20.63 20.63 20.63 0 0 1 -20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83 555.92a34.42 34.42 0 1 0 -.9-68.84 20.66 20.66 0 1 1 -.54-41.31 75.74 75.74 0 1 1 2 151.46 20.66 20.66 0 1 1 -.56-41.31z",
    fill: "#ffc735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.48 703.94a34.41 34.41 0 1 0 0 68.82 136.3 136.3 0 0 1 136.36 136.24 20.66 20.66 0 0 1 -41.32 0 95 95 0 0 0 -95-95 75.69 75.69 0 1 1 0-151.38 20.64 20.64 0 1 1 0 41.28z",
    fill: "#ffc735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m873.07 69.22a137.78 137.78 0 0 0 -137.75 137.78 20.67 20.67 0 1 1 -41.32 0c0-98.94 80.18-179.14 179.08-179.14a20.67 20.67 0 0 1 0 41.34z",
    fill: "#ffc735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1069.87 196.43a126.64 126.64 0 0 0 -126.62-126.66 20.65 20.65 0 0 1 0-41.3 167.93 167.93 0 0 1 167.91 168 20.65 20.65 0 1 1 -41.29 0z",
    fill: "#2dce89",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.35 576.87a20.62 20.62 0 1 1 20.89 20.36 20.63 20.63 0 0 1 -20.89-20.36z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.22 929.65a20.63 20.63 0 1 1 20.62-20.65 20.63 20.63 0 0 1 -20.62 20.65z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.38 1074.05a20.63 20.63 0 1 1 20.62-20.63 20.62 20.62 0 0 1 -20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.54 1128.86a20.63 20.63 0 1 1 20.62-20.62 20.62 20.62 0 0 1 -20.62 20.62z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.22 984.46a20.63 20.63 0 1 1 20.62-20.62 20.63 20.63 0 0 1 -20.62 20.62z",
    fill: "#5e72e4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.22 1039.87a20.63 20.63 0 1 1 20.62-20.63 20.63 20.63 0 0 1 -20.62 20.63z",
    fill: "#5e72e4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.77 1081.12a20.63 20.63 0 1 1 20.62-20.62 20.62 20.62 0 0 1 -20.62 20.62z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.77 1135.94a20.63 20.63 0 1 1 20.62-20.63 20.63 20.63 0 0 1 -20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.91 703.91a20.63 20.63 0 1 1 20.62-20.62 20.63 20.63 0 0 1 -20.62 20.62z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1412.67 496.2a75.71 75.71 0 0 1 -75.73 75.69h-137.68a75.69 75.69 0 1 1 0-151.38h44.06v-43.35a75.7 75.7 0 0 1 75.68-75.68h137.69a34.42 34.42 0 0 0 34.42-34.41v-63.3a34.42 34.42 0 0 0 -34.42-34.41 20.64 20.64 0 1 1 0-41.28 75.71 75.71 0 0 1 75.72 75.69v63.3a75.48 75.48 0 0 1 -23.75 55.05 75.48 75.48 0 0 1 23.75 55v61.93a20.65 20.65 0 0 1 -41.3 0v-61.89a34.41 34.41 0 0 0 -34.42-34.4h-137.69a34.41 34.41 0 0 0 -34.42 34.4v43.35h52.32a75.71 75.71 0 0 1 75.77 75.69zm-213.41-34.4a34.41 34.41 0 1 0 0 68.81h137.68a34.41 34.41 0 1 0 0-68.81z",
    fill: "#2dce89",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1103.59 298a45.36 45.36 0 1 0 -4.11-82.28 20.62 20.62 0 1 1 -19-36.62 87.21 87.21 0 0 1 73-3.27c44.45 18.08 66 68.61 47.89 113s-68.93 65.46-113.37 47.38a20.62 20.62 0 1 1 15.59-38.21z",
    fill: "#ffc735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1412.25 500.57a94.88 94.88 0 0 0 94.87 94.9 20.63 20.63 0 0 1 0 41.25 136.12 136.12 0 0 1 -136.12-136.15 20.62 20.62 0 1 1 41.24 0z",
    fill: "#ffc735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1391.63 520a20.63 20.63 0 1 1 20.62-20.62 20.62 20.62 0 0 1 -20.62 20.62z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.89 1174.84a94.88 94.88 0 0 0 94.87-94.84 20.62 20.62 0 1 1 41.24 0 136.12 136.12 0 0 1 -136.11 136.14 20.63 20.63 0 0 1 0-41.25z",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1467.34 1216.09a75.67 75.67 0 0 1 -75.71-75.63v-137.53a75.72 75.72 0 0 1 151.43 0v137.53a75.67 75.67 0 0 1 -75.72 75.63zm34.42-75.63v-137.53a34.42 34.42 0 0 0 -68.83 0v137.53a34.42 34.42 0 0 0 68.83 0z",
    fill: "#2dce89",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1488.38 948a75.68 75.68 0 0 1 75.83-75.53 20.6 20.6 0 1 0 0-41.2c-64.72 0-117.2 52.26-117.2 116.73a20.69 20.69 0 0 0 41.37 0z",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1488.26 947.92a20.63 20.63 0 1 0 -20.62 20.63 20.63 20.63 0 0 0 20.62-20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1282.92 1105.93a34.43 34.43 0 1 0 34.41 34.43 34.43 34.43 0 0 0 -34.41-34.43zm-75.72 34.43a75.72 75.72 0 1 1 75.72 75.73 75.73 75.73 0 0 1 -75.72-75.73z",
    fill: "#ffc735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1138.32 1027.19a34.42 34.42 0 1 0 34.41-34.42 20.66 20.66 0 0 1 0-41.31 75.74 75.74 0 1 1 -75.71 75.73 20.65 20.65 0 1 1 41.3 0z",
    fill: "#5e72e4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1138.26 1026.9a20.62 20.62 0 1 1 -20.62-20.63 20.63 20.63 0 0 1 20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1248.45 1140.65a20.63 20.63 0 1 1 -20.62-20.63 20.63 20.63 0 0 1 20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1303.83 1140.06a20.62 20.62 0 1 1 -20.62-20.63 20.62 20.62 0 0 1 20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1313.22 68a133.65 133.65 0 0 0 -133.63 133.67 20.67 20.67 0 1 1 -41.33 0c0-96.65 78.33-175 175-175a20.67 20.67 0 0 1 0 41.34z",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1277.32 1012.17a94.88 94.88 0 0 0 -94.86-94.9 20.63 20.63 0 1 1 0-41.25 136.13 136.13 0 0 1 136.11 136.15 20.63 20.63 0 0 1 -41.25 0z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.85 1080a94.88 94.88 0 0 0 94.87 94.89 20.63 20.63 0 0 1 0 41.25 136.12 136.12 0 0 1 -136.11-136.14 20.62 20.62 0 1 1 41.24 0z",
    fill: "#2dce89",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.8 141a34.43 34.43 0 1 1 34.41-34.42 34.42 34.42 0 0 1 -34.41 34.42zm-75.72-34.42a75.72 75.72 0 1 0 75.72-75.75 75.73 75.73 0 0 0 -75.72 75.74z",
    fill: "#ffc735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.05 198.81a20.63 20.63 0 0 1 20.62 20.65 34.4 34.4 0 0 0 34.33 34.42h137.53a34.4 34.4 0 0 0 34.37-34.42 20.62 20.62 0 1 1 41.24 0 75.66 75.66 0 0 1 -75.61 75.72h-134.74a34.4 34.4 0 0 0 -34.37 34.42v137.69a34.4 34.4 0 0 0 34.37 34.42 20.65 20.65 0 0 1 0 41.3 75.66 75.66 0 0 1 -75.61-75.72v-137.69a75.58 75.58 0 0 1 22.37-53.77 75.58 75.58 0 0 1 -25.12-56.37 20.63 20.63 0 0 1 20.62-20.65z",
    fill: "#2dce89",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222 144.18a84 84 0 0 1 79.91-57.95h79.82a20.58 20.58 0 1 1 0 41.16h-79.87a42.66 42.66 0 0 0 -41.05 30.89 75.37 75.37 0 0 1 31.33 61.2 20.62 20.62 0 0 1 -41.24 0 34.34 34.34 0 0 0 -34.37-34.31h-137.53a34.34 34.34 0 0 0 -34.37 34.31 20.62 20.62 0 0 1 -41.24 0 75.55 75.55 0 0 1 75.61-75.48h137.53c1.82 0 3.63.07 5.42.19z",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m292.2 219.73a34.42 34.42 0 1 1 34.41 34.43 20.66 20.66 0 0 0 0 41.31 75.74 75.74 0 1 0 -75.71-75.74 20.65 20.65 0 1 0 41.3 0z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.14 220a20.62 20.62 0 1 0 -20.62 20.63 20.62 20.62 0 0 0 20.62-20.63z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.67 219.43a20.62 20.62 0 1 0 -20.62 20.63 20.62 20.62 0 0 0 20.62-20.63z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.52 345a20.62 20.62 0 1 0 -20.62 20.6 20.62 20.62 0 0 0 20.62-20.6z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.52 399.79a20.62 20.62 0 1 0 -20.62 20.63 20.63 20.63 0 0 0 20.62-20.63z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.15 1196.64a20.62 20.62 0 1 0 -20.62 20.63 20.62 20.62 0 0 0 20.62-20.63z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 1196.64a20.62 20.62 0 1 0 -20.62 20.63 20.62 20.62 0 0 0 20.62-20.63z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.21 1195.47a20.62 20.62 0 1 0 -20.62 20.62 20.62 20.62 0 0 0 20.62-20.62z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.33 106.86a20.63 20.63 0 1 0 -20.62 20.63 20.63 20.63 0 0 0 20.62-20.63z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.72 106.86a20.63 20.63 0 1 0 -20.63 20.63 20.63 20.63 0 0 0 20.63-20.63z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.63 198.75a34.43 34.43 0 0 1 0-68.85 20.66 20.66 0 0 0 0-41.31 75.74 75.74 0 0 0 0 151.47 20.66 20.66 0 0 0 0-41.31z",
    fill: "#ffc735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.06 406.86a94.87 94.87 0 0 1 94.86 94.89 20.63 20.63 0 1 0 41.25 0 136.13 136.13 0 0 0 -136.11-136.15 20.63 20.63 0 0 0 0 41.26z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.59 522.38a20.62 20.62 0 1 0 -20.59 20.62 20.63 20.63 0 0 0 20.59-20.62z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.21 212.36a20.63 20.63 0 1 0 -20.62 20.64 20.63 20.63 0 0 0 20.62-20.64z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1103.94 212.21a20.62 20.62 0 1 1 0-29.17 20.61 20.61 0 0 1 0 29.17z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m963.71 150.33a20.63 20.63 0 1 1 0-29.18 20.64 20.64 0 0 1 0 29.18z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.43 658.53a20.63 20.63 0 0 1 20.62-20.63h65.95a20.63 20.63 0 0 1 0 41.26h-66a20.63 20.63 0 0 1 -20.57-20.63z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m659.82 1213.15a20.6 20.6 0 0 1 -20.62-20.59v-59a20.62 20.62 0 0 1 41.24 0v59a20.6 20.6 0 0 1 -20.62 20.59z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m758.81 1196.64a20.63 20.63 0 0 1 20.64-20.64h163.76a20.63 20.63 0 1 1 0 41.25h-163.76a20.63 20.63 0 0 1 -20.64-20.61z",
    fill: "#ffc735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.43 49.1a20.63 20.63 0 0 1 20.62-20.63h94.86a20.63 20.63 0 0 1 0 41.26h-94.86a20.63 20.63 0 0 1 -20.62-20.63z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m948.54 1217.27a20.63 20.63 0 1 1 20.62-20.63 20.63 20.63 0 0 1 -20.62 20.63z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1366.14 693.75a20.63 20.63 0 1 1 0-29.18 20.62 20.62 0 0 1 0 29.18z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1424.47 693.75a20.63 20.63 0 1 1 0-29.18 20.62 20.62 0 0 1 0 29.18z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1562.47 771.17c-98.88 0-179 80.18-179 179.08a20.66 20.66 0 0 1 -41.32 0c0-121.73 98.64-220.4 220.34-220.4a20.66 20.66 0 0 1 0 41.32z",
    fill: "#ffc735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1145.33 256.46a20.62 20.62 0 1 1 -20.72-20.52 20.61 20.61 0 0 1 20.72 20.52z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1333.88 47.23a20.62 20.62 0 1 1 -20.72-20.53 20.62 20.62 0 0 1 20.72 20.53z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1145.33 49a20.62 20.62 0 1 1 -20.72-20.53 20.62 20.62 0 0 1 20.72 20.53z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1145.33 103.81a20.62 20.62 0 1 1 -20.72-20.52 20.62 20.62 0 0 1 20.72 20.52z",
    fill: "#fb6340"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1551.88 699.79h-81.88a20.63 20.63 0 1 1 0-41.26h81.87a20.63 20.63 0 1 1 0 41.26z",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1583.12 750.48a20.62 20.62 0 1 1 -20.62-20.63 20.62 20.62 0 0 1 20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1347.38 201.46a34.42 34.42 0 1 0 -34.38 34.42 20.66 20.66 0 0 1 0 41.31 75.74 75.74 0 1 1 75.71-75.73 20.65 20.65 0 0 1 -41.3 0z",
    fill: "#5e72e4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1453.54 59.17a34.43 34.43 0 0 0 0 68.86 20.66 20.66 0 0 1 0 41.31 75.74 75.74 0 0 1 0-151.48 20.66 20.66 0 0 1 0 41.31z",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1335.06 256.57a20.62 20.62 0 1 1 -20.62-20.63 20.62 20.62 0 0 1 20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1475.3 148.71a20.63 20.63 0 1 1 -20.63-20.63 20.63 20.63 0 0 1 20.63 20.63z",
    fill: "#5e72e4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1390.45 256.57a20.63 20.63 0 1 1 -20.62-20.63 20.62 20.62 0 0 1 20.62 20.63z",
    fill: "#5e72e4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1445.25 256.57a20.63 20.63 0 1 1 -20.63-20.63 20.63 20.63 0 0 1 20.63 20.63z",
    fill: "#5e72e4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1477.07 92.72a20.63 20.63 0 1 1 -20.63-20.63 20.63 20.63 0 0 1 20.63 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1531.86 92.72a20.62 20.62 0 1 1 -20.62-20.63 20.62 20.62 0 0 1 20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1587.25 92.72a20.63 20.63 0 1 1 -20.62-20.63 20.62 20.62 0 0 1 20.62 20.63z",
    fill: "#fb6340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1511.83 460.5a20.63 20.63 0 1 1 20.62-20.63 20.63 20.63 0 0 1 -20.62 20.63z",
    fill: "#5e72e4",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.d4194433cc2d354d951ac40f58544427.svg";
export { ForwardRef as ReactComponent };